import { AnalyticsProvider, AnalyticsConfig, AnalyticsUser } from '../types';

/**
 * Раздаёт каждый вызов всем провайдерам. Сбой одного (заблокированный скрипт,
 * ошибка SDK) не должен ломать ни приложение, ни остальные счётчики.
 * Фича-флаги отвечает первый провайдер, у которого есть ответ.
 */
export class CompositeAnalyticsProvider implements AnalyticsProvider {
  constructor(private readonly providers: AnalyticsProvider[]) {}

  private each(fn: (p: AnalyticsProvider) => void): void {
    for (const provider of this.providers) {
      try {
        fn(provider);
      } catch (error) {
        console.error('[analytics] provider failed', error);
      }
    }
  }

  init(config: AnalyticsConfig): void {
    this.each((p) => p.init(config));
  }

  identify(user: AnalyticsUser): void {
    this.each((p) => p.identify(user));
  }

  reset(): void {
    this.each((p) => p.reset());
  }

  track(event: string, properties?: Record<string, unknown>): void {
    this.each((p) => p.track(event, properties));
  }

  pageView(path: string, properties?: Record<string, unknown>): void {
    this.each((p) => p.pageView(path, properties));
  }

  isFeatureEnabled(flag: string): boolean | undefined {
    for (const provider of this.providers) {
      const value = provider.isFeatureEnabled(flag);
      if (value !== undefined) return value;
    }
    return undefined;
  }

  getFeatureFlag(flag: string): string | boolean | undefined {
    for (const provider of this.providers) {
      const value = provider.getFeatureFlag(flag);
      if (value !== undefined) return value;
    }
    return undefined;
  }

  onFeatureFlagsLoaded(callback: () => void): void {
    this.each((p) => p.onFeatureFlagsLoaded(callback));
  }
}
